export const EntitiesEnum = {
	GAME: 'game',
	USER: 'user',
	PREDICTION: 'prediction',
	MARKET_RESULT: 'market result',
	FEATURED_BANNER: 'featured banner',
	MARKET: 'market',
	USER_FAVORITE: 'user favorite',
	USER_TRADE: 'user trade',
	COMMENT: 'comment',
	COMMENT_LIKE: 'comment like',
	EVENT: 'event',
	USER_EVENT: 'user event',
	APP_ANNOUNCEMENT: 'app announcement',
	NOTIFICATION: 'notification',
	FEATURED_EVENT: 'featured event',
	LOBBY: 'lobby',
	WAITLIST: 'waitlist',
	FEATURED_IMAGES: 'featured images',
	BOT_TRADES: 'bot trades',
	MATCH: 'match',
	SLATE: 'slate',
};
